



























import { Component, Prop, Vue } from 'vue-property-decorator'
import { State, Mutation, namespace } from 'vuex-class'

import GlobalFooter from '@/components/page/GlobalFooter.vue'

@Component({
	components: {
		GlobalFooter,
	},
})
export default class PassportLayout extends Vue {
	private links: any[] = [
		{
			title: '帮助',
			href: '#',
			blankTarget: true,
		},
		{
			title: '隐私',
			href: '#',
			blankTarget: true,
		},
		{
			title: '条款',
			href: '#',
			blankTarget: true,
		},
	]
	constructor() {
		super()
	}
}
